import React from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import CloseBtn from '../CloseBtn'

const PrintModal = ({onHide,show,printModal,setPrintModal,submitPrintModal}) => {
  return (
          <Modal show={show} onHide={onHide} centered>
            <CloseBtn onClick={onHide} color="#bf352b" />
        <Modal.Header>
          <Modal.Title>Mark Print as Done</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-0">
              <Form.Label>Print Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Add remarks about the print (e.g., file generated, sent to press, etc.)"
                value={printModal.remarks}
                onChange={(e) =>
                  setPrintModal((d) => ({ ...d, remarks: e.target.value }))
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onHide}
            disabled={printModal.submitting}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={submitPrintModal}
            disabled={printModal.submitting}
          >
            {printModal.submitting ? "Saving..." : "Confirm & Mark Done"}
          </Button>
        </Modal.Footer>
      </Modal>
  )
}

export default PrintModal